<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: "AddButton"
})
</script>

<template>
  <div class="add-structure-button" @click="$emit('click')">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.add-structure-button {
  cursor: pointer;
  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;

  border: 1px solid #FB923C;
  border-radius: 6px;

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
  /* Frame 4 */

  /* Auto layout */
  gap: 10px;

  /* Inside auto layout */
  flex: none;
  flex-grow: 0;
  font-family: Geist;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;

  color: #FB923C;

  .plus {
    /* Frame 4 */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 8px 0 0;
    gap: 10px;

    width: 24px;
    height: 16px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }
}
</style>
